import axios from 'axios';
import { t } from 'i18next';

/** True when the API (or any proxy in front of it) answered 429 — status is the contract. */
export const isRateLimitedError = (err: unknown): boolean =>
    axios.isAxiosError(err) && err.response?.status === 429;

/** Reads the Retry-After header (seconds) of a 429 response, undefined otherwise. */
export const getRateLimitRetryAfter = (err: unknown): unknown =>
    axios.isAxiosError(err) ? err.response?.headers?.['retry-after'] : undefined;

/** User-facing message built from Retry-After — falls back to a generic wording. */
export const formatRateLimitedMessage = (retryAfterHeader: unknown): string => {
    const seconds = Number(retryAfterHeader);
    if (!Number.isFinite(seconds) || seconds <= 0) {
        return t('Trop de tentatives. Réessayez dans quelques minutes.');
    }
    const minutes = Math.max(1, Math.ceil(seconds / 60));
    return minutes === 1
        ? t('Trop de tentatives. Réessayez dans 1 minute.')
        : t('Trop de tentatives. Réessayez dans {{count}} minutes.', { count: minutes });
};
